import React, {FC} from 'react'

import cn from 'classnames/bind'
import Link from 'next/link'

import s from './FormFooter.module.scss'
const cx = cn.bind(s)

interface IFormFooterProps {
	className?: string
	type?: 'sign-up' | 'sign-in'
}

const FormFooter: FC<IFormFooterProps> = ({className, type}) => {
	let config = {
		text: 'Don’t have an account?',
		href: '/auth/sign-up',
		linkText: 'Sign up',
	}

	if (type === 'sign-in') {
		config = {
			text: 'Have an account? ',
			href: '/auth/login',
			linkText: 'Sign in',
		}
	}

	return (
		<footer className={cx('wrapper', className)}>
			<p className={cx('footer__text', 'fs-xs')}>
				{config.text}
				{'  '}
				<Link href={config.href} className={cx('footer__link')}>
					{config.linkText}
				</Link>
			</p>
		</footer>
	)
}

FormFooter.displayName = 'FormFooter'

export default FormFooter
